export default __webpack_public_path__ + "static/media/card3200.b364c322.jpg";